import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import MobileChangeUserForm from "../../../../external/request/request-form/wireless/wireless-change-user.component";
import Icon from "../../../../icon";
import { Col, Row } from "react-bootstrap";
import EmailOptOut from "../../../../external/request/request-form/email-opt-out.component";
import RequestOwnerDetails from "../../../../external/request/request-details/request-owner-details.component";
import RequestOnBehalf from "../../../../external/request/request-form/request-on-behalf.component";
import MobileChangeVendorForm from "../../../../external/request/request-form/wireless/change-vendor/wireless-change-vendor.component";
import MobileChangePricePlanForm from "../../../../external/request/request-form/wireless/wireless-change-price-plan.component";
import MobilePortOutForm from "../../../../external/request/request-form/wireless/wireless-portout.component";
import MobileReplaceSimForm from "../../../../external/request/request-form/wireless/wireless-replace-sim.component";
import MobileTerminateSubscriptionForm from "../../../../external/request/request-form/wireless/wireless-terminate-subscription.component";
import IntlRoamingAccessForm from "../../../../external/request/request-form/wireless/intl-raoming-access.component";
import ReplaceDeviceForm from "../../../../external/request/request-form/wireless/wireless-replace-device.component";
import AccessoryForm from "../../../../external/request/request-form/wireless/wireless-accessory.component";
export class TakeActionModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.resetDefault=this.resetDefault.bind(this);
    this.state={
      show:false,
      clearData:false,
      selected:[],
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {    
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };

  resetDefault() {   
    this.setState({clearData:true});
  }

  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  modalBodyContent(modalType) {
    switch(modalType){
      case 'Change Price Plan':
        return <MobileChangePricePlanForm />
      case 'Change User':
        return <MobileChangeUserForm />;
      case 'Change Vendor':
        return <MobileChangeVendorForm />;
      case 'Port Out':
          return <MobilePortOutForm />;
      case 'Replace Sim':
        return <MobileReplaceSimForm /> ;
      case 'International Roaming Access':
        return <IntlRoamingAccessForm /> ;
      case 'Terminate Subscription':
        return <MobileTerminateSubscriptionForm />;
      case 'Replace Device':
        return <ReplaceDeviceForm />;
      case 'Accessory':
          return <AccessoryForm />;
      default:
        return null;
    }
  }

  render(){
    const {show,selected,clearData }=this.state;
    return(
      <>
      <span className="take-action-list" onClick={this.handleShow.bind(this)}>{this.props.modalType}</span>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-dialog-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.modalType}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row>
            <Col xs={4}>
                <RequestOwnerDetails data={[]} />
            </Col>
            <Col className="second-col-container" xs={7}>               
                <RequestOnBehalf />
                {this.modalBodyContent(this.props.modalType)}
            </Col>
        </Row> 
            
        </Modal.Body>        
      </Modal>

      </>
    );
  }
}
